import { CLIENTS, INDEX } from "../../applications";

export const environment = {
  production: false,
  APP_VERSION: "1.0.0",
  APP_NAME:
    CLIENTS.find((client) => client.index === INDEX)?.appName || "Diet Fit",
  IDENTIFIER:
    CLIENTS.find((client) => client.index === INDEX)?.identifier || "testing",
  LOGIN_PAGE: "onboarding",
  IS_INTERNAL:
    CLIENTS.find((client) => client.index === INDEX)?.identifier === "testing"
      ? true
      : false,
  API_URL: "https://console.dietmaster.fit/api/customer/", // live
  //API_URL: "https://foodna.dietmaster.fit/api/customer/",
  //API_URL: "https://stagingfoodna.dietmaster.fit/api/customer/",
  // API_URL: "http://localhost:8000/api/customer/",
  //API_URL: "https://staging.dietmaster.fit/api/customer/", // testing
  // TABBY_PUBLIC_KEY: "pk_test_0ac0699f-11ef-4183-99f0-063a5bb28084",
  // TABBY_MERCHANT_CODE: "EatSmartkwt"
};
